const { __esModule } = require("bootstrap");

$(document).ready(function() {
  // layout
  // main padding-top
  $(function() {
    var paddingTopMain = function() {
      var heightHeader = $(".melon-container-fixed .melon-header").height();
      var addPaddingTarget = $(".melon-container-fixed .melon-main");
      $(addPaddingTarget).css("padding-top", heightHeader + "px");
    }
    paddingTopMain();
    $(window).resize(function(){
      paddingTopMain();
    });
  })

  // scroll
  var scrollUI = {
    init: function () {
      this.bind();
      this.update(); // 최초 상태 체크
    },

    bind: function () {
      var _this = this;

      $(window).on("scroll", function () {
        _this.update();
      });

      $(window).on("load", function () {
        _this.update();
      });

      window.addEventListener("pageshow", function () {
        _this.update();
      });
    },

    update: function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var $target = $(".melon-container, .melon-header");

      $target.toggleClass("scroll", scrollTop > 0);
    }
  };
  scrollUI.init();

  // bottomsheet scroll
  function modalScroll () {
    var boxSelect = $(".box-bottomsheet");
    $(boxSelect).each(function() {
      var listSelect = $(this).find(".list-bottomsheet");
      var heightListSelect = listSelect.innerHeight();
      var heightBoxSelect = $(this).innerHeight();
      var scrollPadding = heightListSelect - heightBoxSelect;
      var scrollTopValue = $('.inner-box').scrollTop();
      var scrollGap = Math.floor(scrollTopValue - scrollPadding);
      
      if(heightListSelect >= heightBoxSelect) {
        $(this).addClass("scroll");
      } else {
        $(this).removeClass("scroll");
      }
      
      if(scrollGap >= -1) {
        $(this).closest(boxSelect).removeClass("scroll");
      } else {
        $(this).closest(boxSelect).addClass("scroll");
      }
      
      $(this).find(".inner-box").scroll(function(){
        var thisHeightListSelect = $(this).find(".list-bottomsheet").height();
        var thisHeightBoxSelect = $(this).height();
      
        if($(this).scrollTop() >= thisHeightListSelect - thisHeightBoxSelect){
          $(this).closest(boxSelect).removeClass("scroll");
        } else {
          $(this).closest(boxSelect).addClass("scroll");
        }
      });
    })
  }

  // bottomsheet
$(function() {
    modalScroll();
  });

var lastFocusedElement = null;

window.showModal = function(targetModalSelector) {
  var contentAria = $(".melon-container, .fixed_body");
  var $targetModal = $(targetModalSelector);

  lastFocusedElement = $(document.activeElement);

  $('html').addClass("dimmed");
  contentAria.attr('aria-hidden', true);

  $targetModal.show();

  var $modalLayer = $targetModal.find('.modal-layer');
  $modalLayer
    .attr('tabindex', '0')
    .attr('role', 'dialog')
    .attr('aria-modal', 'true')
    .attr('aria-label', '레이어 팝업')
    .focus();

  $targetModal.on('keydown.modalTrap', function(e) {
    if (e.key !== 'Tab') return;

    var focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';
    var $focusable = $modalLayer.find(focusableSelectors).filter(':visible');
    var $first = $focusable.first();
    var $last = $targetModal.find('.btn-close');

    if (e.shiftKey) {
      if ($(document.activeElement).is($first) || $(document.activeElement).is($modalLayer)) {
        e.preventDefault();
        $modalLayer.focus();
      }
    } else {
      if ($(document.activeElement).is($last)) {
        e.preventDefault();
        $modalLayer.focus();
      }
    }
  });
};

window.hideModal = function(targetModalSelector) {
  var $modal = $(targetModalSelector);
  var $modalLayer = $modal.find('.modal-layer');
  var contentAria = $(".melon-container, .fixed_body");

  $modal.off('keydown.modalTrap');
  $modalLayer
    .attr('tabindex', '')
    .removeAttr('role')
    .removeAttr('aria-modal')
    .removeAttr('aria-label');
  $modal.hide();
  $('html').removeClass("dimmed");
  contentAria.attr('aria-hidden', false);

  if (lastFocusedElement && lastFocusedElement.length) {
    lastFocusedElement.focus();
  }
};

// data-target (위임: AJAX로 삽입된 markup에도 동작)
$(document).on("click", "[data-button-type='modal']", function() {
  var target = $(this).attr("data-target");
  if (target) {
    showModal(target);
  }
});

$(document).on("click", ".melon-modal .btn-close, .melon-modal .btn-cancel", function() {
  var $modal = $(this).closest(".melon-modal");
  hideModal('#' + $modal.attr('id'));
});

  // floating
  $(function() {
    var btnCloseFloating = $(".melon-floating .btn-close");
    $(btnCloseFloating).on("click", function() {
      $(this).closest(".melon-floating").hide();
    })
  });

  // text wrap - fold
  $(function() {
    var textWrap = $(".text-wrap")
    // n줄이상 더보기
    var txtOverflow = function() {
      $(textWrap).each(function (index, item) {
        var innerTextWrap = $(this).find(".txt-g");
        var heightCmtText = $(this).innerHeight();
        var heightCmTxt = innerTextWrap.innerHeight();
        if(heightCmTxt > heightCmtText) {
          $(this).addClass("text-overflow");
        } else {
          $(this).removeClass("text-overflow");
        }
      })
    }
    txtOverflow();
    $(window).resize(function(){
      txtOverflow();
    });
    // 더보기/접기
    var btnTxtFold = $(textWrap).find(".btn-text");
    $(btnTxtFold).on("click", function() {
      $(this).closest(textWrap).toggleClass("text-open");
    })
  });

  // play button - scroll fixed 
  $(function() {
    var btnPlayFixed = function() {
      var heightHeader = $(".melon-container .melon-header").innerHeight();
      var targetPlayAction = $(".play-action-fixed");
      $(targetPlayAction).each(function() {
        var innerPlayAction = $(this).find(".inner-play-action");
        var heightInnerPlayAction = $(innerPlayAction).innerHeight();
        var topPlayAction = $(this).offset().top;
        var topCurrent = $(document).scrollTop();
        if(topCurrent > topPlayAction - heightHeader - 4){
          $(targetPlayAction).addClass("fixed").css("height", heightInnerPlayAction + "px");;
          $(innerPlayAction).css("top", heightHeader + "px");
        } else {
          $(targetPlayAction).removeClass("fixed").css("height", "");
          $(innerPlayAction).css("top", "");
        }
      });
    };
    $(window).scroll(function(){ 
      btnPlayFixed();
    });
    $(window).resize(function(){
      btnPlayFixed();
    });
  });

  // wrap info list - scroll fixed 
  $(function() {
    var listInfoFixed = function() { 
      var heightHeader = $(".melon-container .melon-header").innerHeight();
      var targetWrapInfo = $(".wrap-info-fixed");
      $(targetWrapInfo).each(function() {
        var innerInfo = $(this).find(".inner-info-list");
        var heightInnerInfo = $(innerInfo).innerHeight();
        var topWrapInfo= $(this).offset().top;
        var topCurrent = $(document).scrollTop();
        var heightPlayAction = $(".play-action-fixed .inner-play-action").innerHeight();
        if(topCurrent > topWrapInfo - heightHeader - heightPlayAction - 7){
          $(targetWrapInfo).addClass("fixed").css("height", heightInnerInfo + "px");;
          $(innerInfo).css("top", heightHeader + heightPlayAction + "px");
        } else {
          $(targetWrapInfo).removeClass("fixed").css("height", "");
          $(innerInfo).css("top", "");
        }
      });
    };
    $(window).scroll(function(){ 
      listInfoFixed();
    });
    $(window).resize(function(){
      listInfoFixed();
    });
  });

  // 더보기 리스트
  $(function() {
    // 아티스트 더보기 없을 경우 여부 확인
    var DataList = function(part, list, max) {
        $(this).part = part;
        $(this).list = list;
        $(this).max = max;
        var dataBox = $(part);
        dataBox.each(function (index, item) {
          var dataLength = $(this).find(list).length;
          var areaMore = $(this).find(".area-more");
          if(dataLength < max) {
            areaMore.css("display", "none");
          }
        });
    }
    var dataListOpen = new DataList('.data-list', 'li', '3');
    var dataListOpen2 = new DataList('.data-list2', 'li', '5');

    // 텍스트 라인 수에 따르는 경우 (아티스트 소개)
    var DataView = function(part, data, height) {
      $(this).part = part;
      $(this).data = data;
      var dataBox = $(part);
      dataBox.each(function (index, item) {
        var dataHeight = $(this).find(data).height();
        var areaMore = $(this).find(".area-more");
        var contHeight = Number(height);
        if(dataHeight < contHeight) {
          areaMore.css("display", "none");
        } else {
          areaMore.css("display", "");
        }
      });
    }

    // 앨범 > 가사 더보기
    var DataView2 = function(part, data, height) {
      $(this).part = part;
      $(this).data = data;
      var dataBox = $(part);
      dataBox.each(function (index, item) {
        var dataHeight = $(this).find(data).height();
        var areaMore = $(this).find(".area-more");
        var contHeight = $(this).find(height).height();
        if(dataHeight >= contHeight) {
          areaMore.css("display", "none");
        } else {
          areaMore.css("display", "");
          $(".txt-lyrics").addClass('txt-clamp');
        }
      });
    }

    var dataViewOpen = new DataView('.data-view', '.unit-cont', '208');
    var dataViewOpen2 = new DataView2('.data-view2', '.txt-out', '.txt-lyrics');

    $(window).resize(function() {
      //창크기 변화 감지
      var dataViewOpen = new DataView('.data-view', '.unit-cont', '208');
    });
    
    
    // 더보기 컨텐츠 버튼 화살표 (btn-more-data가 있을 경우만)
    var viewMore = function(data) {
      $(data).each(function (index, item) {
        var contentFold = data.hasClass('open-more');
        var btnMore = $(this).find(".btn-more-data");
        if(contentFold) {
          data.removeClass('open-more');
          btnMore.removeClass('on');
        } else {
          data.addClass('open-more');
          btnMore.addClass('on');
        }
      });
    }

    // 더보기 클릭 버튼명 수정 (공통)
    var clickFold = function(){
      var buttonFold = $(".data-view").find(".btn-more-data"); // 소개 더보기 - 5줄 이상 더보기 / 접기
      var buttonFoldLyric = $(".data-view2").find(".btn-more"); // 가사 더보기 - 15줄 이상 더보기 / 접기
      var buttonFold2 = $(".data-list").find(".btn-more-data") ; // 아티스트 더보기  - 3리스트 이상 더보기만
      var buttonFold3 = $(".data-list2").find(".btn-more-data"); // 매거진 더보기  - 5리스트 이상 더보기만

      var ViewFold = function(item){
        $(item).on("click", function() {
          var data = $(this).parent().parent();
          var textFold = $(this).find(".txt-g");
          textFold.text(textFold.text() == '더보기' ? '접기' : '더보기');
          if(data) {
            viewMore(data);
          }
          if(item === buttonFoldLyric) {
            $('html, body').animate({scrollTop : 420});
          }
        });
      }
      var viewFold = new ViewFold(buttonFold);
      var viewFoldLyric = new ViewFold(buttonFoldLyric);
      var viewFold2 = new ViewFold(buttonFold2);
      var viewFold3 = new ViewFold(buttonFold3);
    }
    clickFold();
  });

});